import { SiteUrls } from '@tableau/shared-urls';

import { IErrorStateParams } from '../controllers/ErrorCtrl';
import { ILocLinkifierModel, LinkTargetAttributes } from '../filters/LocLinkifierFilter';
import { IUserInfo } from '../models/IUserInfo';
import { ErrorState } from '../services/ErrorState';

export namespace DataAlertErrorStateHelper {
  export function redirectToNoDataAlertError(viewUrl: string, errorState: ErrorState) {
    const linkifierModel: ILocLinkifierModel = {
      localizedStatementKey: 'dataAlertInvalidAlertUrlError',
      links: [
        {
          key: '{THE_VIEW}',
          localizedValueKey: 'dataAlertErrorViewLinkText',
          url: viewUrl,
          target: LinkTargetAttributes.Self
        }
      ]
    };

    const vizErrorState: IErrorStateParams = {
      detailsLinkifierModel: JSON.stringify(linkifierModel), // implies user data alerts page
      redirectLocKey: 'goToMyAlerts'
    };

    errorState.go(vizErrorState);
  }

  export function redirectToBadPermissionsDataAlertError(viewUrl: string, owner: IUserInfo,
                                                  errorState: ErrorState, siteUrls: SiteUrls) {
    const linkifierModel: ILocLinkifierModel = {
      localizedStatementKey: 'dataAlertBadPermissionsError',
      links: [
        {
          key: '{THE_VIEW}',
          localizedValueKey: 'dataAlertErrorViewLinkText',
          url: viewUrl,
          target: LinkTargetAttributes.Self
        },
        {
          key: '{OWNER}',
          localizedValue: owner.displayName,
          url: siteUrls.userContentUrl(owner.username, owner.domainName),
          target: LinkTargetAttributes.Self
        }
      ]
    };

    const vizErrorState: IErrorStateParams = {
      detailsLinkifierModel: JSON.stringify(linkifierModel), // implies user data alerts page
      redirectLocKey: 'goToMyAlerts'
    };

    errorState.go(vizErrorState);
  }

  export function redirectToViewerCantEditDataAlertError(errorState: ErrorState) {
    const linkifierModel: ILocLinkifierModel = {
      localizedStatementKey: 'viewerCannotEditDataAlertError'
    };

    const vizErrorState: IErrorStateParams = {
      detailsLinkifierModel: JSON.stringify(linkifierModel), // implies user data alerts page
      redirectLocKey: 'goToMyAlerts'
    };

    errorState.go(vizErrorState);
  }
}
